import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { Router } from 'react-router-dom';

import MuiThemeProvider from '@material-ui/core/styles/MuiThemeProvider';

// i18n
import { addLocaleData, IntlProvider } from 'react-intl';
import pt from 'react-intl/locale-data/pt';
import es from 'react-intl/locale-data/es';
import en from 'react-intl/locale-data/en';
import { localeBuilder, flattenMessages } from './i18n/utils';
import messages from './i18n/messages';

// Redux
import { history, configureStore } from './store/configureStore';

import './index.css';
import './scss/gestorpublicacoesdoe.scss';
import * as serviceWorker from './serviceWorker';
import theme from './utils/theme';

import { initializeReactGA } from './commons/analytics';
import { GlobalLoading } from './components/loading/Loading';

addLocaleData([...pt, ...es, ...en]);
const { languages } = navigator;
const locale = localeBuilder(languages);
const reduxStore = configureStore();

initializeReactGA();

const PainelAtos = React.lazy(() => import('./features/painelAtos/PainelAtos'));

ReactDOM.render(
  <IntlProvider
    locale={locale}
    messages={flattenMessages(messages[locale])}
    textComponent={React.Fragment}
  >
    <Suspense fallback={<GlobalLoading />}>
      <Provider store={reduxStore}>
        <Router history={history}>
          <MuiThemeProvider theme={theme}>
            <PainelAtos />
          </MuiThemeProvider>
        </Router>
      </Provider>
    </Suspense>
  </IntlProvider>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
